// See EnrollHostsDrawer.spec.md for EHD-FR-001
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import Text from 'core/elements/Text'
import colors from 'core/themes/base/colors'
import type Theme from 'core/themes/model'

interface Props {
  title: string
  description: string
  className?: string
}

// The grey card at the top of every Enroll Hosts step: title, description, and (on steps 1
// and 2) the step's main field. Matches the stepper's own step header box.
export default function StepSection({
  title,
  description,
  className,
  children,
}: PropsWithChildren<Props>) {
  const classes = useStyles()
  return (
    <div className={clsx(classes.section, className)}>
      <Text variant="subtitle2">{title}</Text>
      <Text variant="body2" className={classes.description}>
        {description}
      </Text>
      {children}
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    border: `1px solid ${colors.grey[200]}`,
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2, 4),
    // Figma: dropdown labels in the card are 700 (the shared dropdown label is 600)
    '& .dropdown-container .label': {
      fontWeight: 700,
    },
    // Figma: dropdowns keep their white fill while disabled (shared disabled style is grey)
    '& .dropdown-container .inputFrame': {
      backgroundColor: theme.components.input.frame.background,
    },
  },
  description: {
    color: colors.grey[700],
  },
}))
